import { Injectable } from '@angular/core';
import { RiskModuleConfig } from '../agility-risk.config.interface';

@Injectable({
  providedIn: 'root'
})
export class ThemeServiceConfig {
  public theme: string;
}

@Injectable({
  providedIn: 'root'
})
export class AgilityRiskThemeService {
  private themeConfig: ThemeServiceConfig;

  constructor(config: ThemeServiceConfig) {
    this.themeConfig = config;
  }

  getTheme(): string {
    return this.themeConfig.theme;
  }
}

export function provideThemeServiceConfig(riskModuleConfig?: RiskModuleConfig): ThemeServiceConfig {
  const themeServiceConfig = new ThemeServiceConfig();

  if (riskModuleConfig) {
    themeServiceConfig.theme = riskModuleConfig.theme;
  }

  return (themeServiceConfig);
}
